/* tslint:disable */
/* eslint-disable */
/**
 * chinaone-java
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {
  FinalStockErrorGoodsProcessVo,
  OrderCheckAddOrUpdateVo,
  ProcessNormalErrorGoodsReqVo,
  ProcessStockErrorGoodsReqVo,
  ResponseNormalOrderCheckInfoVo,
  ResponseStockOrderCheckInfoVo,
  ResponseStockOrderCheckWithSkuInfoVo,
  ResponseString,
} from '../models/index';
import {
    FinalStockErrorGoodsProcessVoFromJSON,
    FinalStockErrorGoodsProcessVoToJSON,
    OrderCheckAddOrUpdateVoFromJSON,
    OrderCheckAddOrUpdateVoToJSON,
    ProcessNormalErrorGoodsReqVoFromJSON,
    ProcessNormalErrorGoodsReqVoToJSON,
    ProcessStockErrorGoodsReqVoFromJSON,
    ProcessStockErrorGoodsReqVoToJSON,
    ResponseNormalOrderCheckInfoVoFromJSON,
    ResponseNormalOrderCheckInfoVoToJSON,
    ResponseStockOrderCheckInfoVoFromJSON,
    ResponseStockOrderCheckInfoVoToJSON,
    ResponseStockOrderCheckWithSkuInfoVoFromJSON,
    ResponseStockOrderCheckWithSkuInfoVoToJSON,
    ResponseStringFromJSON,
    ResponseStringToJSON,
} from '../models/index';

export interface OrderCheckAddOrUpdateCheckStockOrderOrderIdPostRequest {
    orderId: number;
    orderCheckAddOrUpdateVo?: Array<OrderCheckAddOrUpdateVo>;
}

export interface OrderCheckAdminProcessStockOrderGoodsErrorOrderIdPostRequest {
    orderId: number;
    finalStockErrorGoodsProcessVo?: Array<FinalStockErrorGoodsProcessVo>;
}

export interface OrderCheckCancelStockErrorGoodsProcessOrderIdPutRequest {
    orderId: number;
    processGroup: number;
}

export interface OrderCheckGetNormalOrderGoodsCheckInfoOrderIdGetRequest {
    orderId: number;
}

export interface OrderCheckGetStockOrderCheckInfoOrderIdGetRequest {
    orderId: number;
}

export interface OrderCheckGetStockOrderGoodsCheckInfoOrderIdGetRequest {
    orderId: number;
}

export interface OrderCheckProcessNormalErrorGoodsPostRequest {
    processNormalErrorGoodsReqVo?: ProcessNormalErrorGoodsReqVo;
}

export interface OrderCheckProcessStockErrorGoodsPostRequest {
    processStockErrorGoodsReqVo?: ProcessStockErrorGoodsReqVo;
}

/**
 * 
 */
export class OrderCheckControllerApi extends runtime.BaseAPI {

    /**
     * 
     * 添加或修改库存订单检查
     */
    async orderCheckAddOrUpdateCheckStockOrderOrderIdPostRaw(requestParameters: OrderCheckAddOrUpdateCheckStockOrderOrderIdPostRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ResponseString>> {
        if (requestParameters['orderId'] == null) {
            throw new runtime.RequiredError(
                'orderId',
                'Required parameter "orderId" was null or undefined when calling orderCheckAddOrUpdateCheckStockOrderOrderIdPost().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/orderCheck/addOrUpdate/checkStockOrder/{orderId}`.replace(`{${"orderId"}}`, encodeURIComponent(String(requestParameters['orderId']))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters['orderCheckAddOrUpdateVo']!.map(OrderCheckAddOrUpdateVoToJSON),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ResponseStringFromJSON(jsonValue));
    }

    /**
     * 
     * 添加或修改库存订单检查
     */
    async orderCheckAddOrUpdateCheckStockOrderOrderIdPost(requestParameters: OrderCheckAddOrUpdateCheckStockOrderOrderIdPostRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ResponseString> {
        const response = await this.orderCheckAddOrUpdateCheckStockOrderOrderIdPostRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * 
     * 管理端 最终处理订单商品检查信息
     */
    async orderCheckAdminProcessStockOrderGoodsErrorOrderIdPostRaw(requestParameters: OrderCheckAdminProcessStockOrderGoodsErrorOrderIdPostRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ResponseString>> {
        if (requestParameters['orderId'] == null) {
            throw new runtime.RequiredError(
                'orderId',
                'Required parameter "orderId" was null or undefined when calling orderCheckAdminProcessStockOrderGoodsErrorOrderIdPost().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/orderCheck/adminProcessStockOrderGoodsError/{orderId}`.replace(`{${"orderId"}}`, encodeURIComponent(String(requestParameters['orderId']))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters['finalStockErrorGoodsProcessVo']!.map(FinalStockErrorGoodsProcessVoToJSON),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ResponseStringFromJSON(jsonValue));
    }

    /**
     * 
     * 管理端 最终处理订单商品检查信息
     */
    async orderCheckAdminProcessStockOrderGoodsErrorOrderIdPost(requestParameters: OrderCheckAdminProcessStockOrderGoodsErrorOrderIdPostRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ResponseString> {
        const response = await this.orderCheckAdminProcessStockOrderGoodsErrorOrderIdPostRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * 
     * 取消订单错误商品处理
     */
    async orderCheckCancelStockErrorGoodsProcessOrderIdPutRaw(requestParameters: OrderCheckCancelStockErrorGoodsProcessOrderIdPutRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ResponseString>> {
        if (requestParameters['orderId'] == null) {
            throw new runtime.RequiredError(
                'orderId',
                'Required parameter "orderId" was null or undefined when calling orderCheckCancelStockErrorGoodsProcessOrderIdPut().'
            );
        }

        if (requestParameters['processGroup'] == null) {
            throw new runtime.RequiredError(
                'processGroup',
                'Required parameter "processGroup" was null or undefined when calling orderCheckCancelStockErrorGoodsProcessOrderIdPut().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['processGroup'] != null) {
            queryParameters['processGroup'] = requestParameters['processGroup'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/orderCheck/cancelStockErrorGoodsProcess/{orderId}`.replace(`{${"orderId"}}`, encodeURIComponent(String(requestParameters['orderId']))),
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ResponseStringFromJSON(jsonValue));
    }

    /**
     * 
     * 取消订单错误商品处理
     */
    async orderCheckCancelStockErrorGoodsProcessOrderIdPut(requestParameters: OrderCheckCancelStockErrorGoodsProcessOrderIdPutRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ResponseString> {
        const response = await this.orderCheckCancelStockErrorGoodsProcessOrderIdPutRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * 
     * 客户端 获取普通订单商品检查信息
     */
    async orderCheckGetNormalOrderGoodsCheckInfoOrderIdGetRaw(requestParameters: OrderCheckGetNormalOrderGoodsCheckInfoOrderIdGetRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ResponseNormalOrderCheckInfoVo>> {
        if (requestParameters['orderId'] == null) {
            throw new runtime.RequiredError(
                'orderId',
                'Required parameter "orderId" was null or undefined when calling orderCheckGetNormalOrderGoodsCheckInfoOrderIdGet().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/orderCheck/getNormalOrderGoodsCheckInfo/{orderId}`.replace(`{${"orderId"}}`, encodeURIComponent(String(requestParameters['orderId']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ResponseNormalOrderCheckInfoVoFromJSON(jsonValue));
    }

    /**
     * 
     * 客户端 获取普通订单商品检查信息
     */
    async orderCheckGetNormalOrderGoodsCheckInfoOrderIdGet(requestParameters: OrderCheckGetNormalOrderGoodsCheckInfoOrderIdGetRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ResponseNormalOrderCheckInfoVo> {
        const response = await this.orderCheckGetNormalOrderGoodsCheckInfoOrderIdGetRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * 
     * 入库检查信息回显，库存订单入库检查的第一步那个页面
     */
    async orderCheckGetStockOrderCheckInfoOrderIdGetRaw(requestParameters: OrderCheckGetStockOrderCheckInfoOrderIdGetRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ResponseStockOrderCheckWithSkuInfoVo>> {
        if (requestParameters['orderId'] == null) {
            throw new runtime.RequiredError(
                'orderId',
                'Required parameter "orderId" was null or undefined when calling orderCheckGetStockOrderCheckInfoOrderIdGet().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/orderCheck/getStockOrderCheckInfo/{orderId}`.replace(`{${"orderId"}}`, encodeURIComponent(String(requestParameters['orderId']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ResponseStockOrderCheckWithSkuInfoVoFromJSON(jsonValue));
    }

    /**
     * 
     * 入库检查信息回显，库存订单入库检查的第一步那个页面
     */
    async orderCheckGetStockOrderCheckInfoOrderIdGet(requestParameters: OrderCheckGetStockOrderCheckInfoOrderIdGetRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ResponseStockOrderCheckWithSkuInfoVo> {
        const response = await this.orderCheckGetStockOrderCheckInfoOrderIdGetRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * 
     * 获取订单商品检查信息
     */
    async orderCheckGetStockOrderGoodsCheckInfoOrderIdGetRaw(requestParameters: OrderCheckGetStockOrderGoodsCheckInfoOrderIdGetRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ResponseStockOrderCheckInfoVo>> {
        if (requestParameters['orderId'] == null) {
            throw new runtime.RequiredError(
                'orderId',
                'Required parameter "orderId" was null or undefined when calling orderCheckGetStockOrderGoodsCheckInfoOrderIdGet().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/orderCheck/getStockOrderGoodsCheckInfo/{orderId}`.replace(`{${"orderId"}}`, encodeURIComponent(String(requestParameters['orderId']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ResponseStockOrderCheckInfoVoFromJSON(jsonValue));
    }

    /**
     * 
     * 获取订单商品检查信息
     */
    async orderCheckGetStockOrderGoodsCheckInfoOrderIdGet(requestParameters: OrderCheckGetStockOrderGoodsCheckInfoOrderIdGetRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ResponseStockOrderCheckInfoVo> {
        const response = await this.orderCheckGetStockOrderGoodsCheckInfoOrderIdGetRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * 
     * 客户端 处理普通订单错误商品
     */
    async orderCheckProcessNormalErrorGoodsPostRaw(requestParameters: OrderCheckProcessNormalErrorGoodsPostRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ResponseString>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/orderCheck/processNormalErrorGoods`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: ProcessNormalErrorGoodsReqVoToJSON(requestParameters['processNormalErrorGoodsReqVo']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ResponseStringFromJSON(jsonValue));
    }

    /**
     * 
     * 客户端 处理普通订单错误商品
     */
    async orderCheckProcessNormalErrorGoodsPost(requestParameters: OrderCheckProcessNormalErrorGoodsPostRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ResponseString> {
        const response = await this.orderCheckProcessNormalErrorGoodsPostRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * 
     * 处理订单错误商品
     */
    async orderCheckProcessStockErrorGoodsPostRaw(requestParameters: OrderCheckProcessStockErrorGoodsPostRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ResponseString>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/orderCheck/processStockErrorGoods`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: ProcessStockErrorGoodsReqVoToJSON(requestParameters['processStockErrorGoodsReqVo']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ResponseStringFromJSON(jsonValue));
    }

    /**
     * 
     * 处理订单错误商品
     */
    async orderCheckProcessStockErrorGoodsPost(requestParameters: OrderCheckProcessStockErrorGoodsPostRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ResponseString> {
        const response = await this.orderCheckProcessStockErrorGoodsPostRaw(requestParameters, initOverrides);
        return await response.value();
    }

}
